//workStatus, week
import { useEffect, useMemo, useRef, useState } from "react"; 
//-------------------------------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Modal from "src/components/common/modal";
import PMNumbers from "src/components/common/PMNumbers";
import {
    calcLocate, 
    getFirstNonLunchIndex, 
    isMobilePhone, 
    getDatefromWeekNum, 
    myAxios, 
    MyFormData,
    arrayReducer, 
    LMStatusOpts,
    getDateEndFromWeekNum, 
    getTimeStamp, 
} from "src/components/common/functions";
//-------------------------------------------------------------------------------------------------------------------
export default function LocatorForm({
    closeIt, 
    defaultData, 
    week, 
    dayIndex, 
    admin, 
    email, 
    userName, 
    lanId, 
    outside, 
}){
    class offlineStorage {
        constructor(emailName, weekName, dayName, dataName){
            this.emailName = emailName;
            this.weekName = weekName;
            this.dayName = dayName;
            this.dataName = dataName;
        }
        setDataSet(email, week, day, dataStr){
            localStorage.setItem(this.emailName, email);
            localStorage.setItem(this.weekName, week);
            localStorage.setItem(this.dayName, day);
            localStorage.setItem(this.dataName, dataStr);
        }
        removeDataSet(){
            // localStorage.clear();
            localStorage.removeItem(this.emailName);
            localStorage.removeItem(this.weekName);
            localStorage.removeItem(this.dayName);
            localStorage.removeItem(this.dataName);
        }
        getEmail(){
            return localStorage.getItem(this.emailName);
        }
        getWeek(){
            return localStorage.getItem(this.weekName);
        }
        getDay(){
            return localStorage.getItem(this.dayName);
        }
        getData(){
            return localStorage.getItem(this.dataName);
        }
    }
    const useOfflineStorage = (emailName, weekName, dayName, dataName) => {
        return useMemo(() => {
          return new offlineStorage(emailName, weekName, dayName, dataName);
        }, [emailName, weekName, dayName, dataName]);
    }
    const store = useOfflineStorage("outsideLocater_email", "outsideLocater_currentWeek","outsideLocater_currentDay", "outsideLocater_data");
    //-------------------------------------------------------------------------------------------------------------------
    const eventOptions = [
        "Vehicle Maintenance", "Supply Run", "Bess Call", 
        "PG&E Call","Calibration", "Drug Testing", 
        "Training", "TSC", "PG&E WBT", 
        "BESS Training", "PG&E Non-Productive time", 
        "BESS Non-Productive time", "Fiber Optic Locates",
        "Digital Catalyst" , "Miscellaneous Charges"
    ];
    const modalWidth = "80%";
    const weekTitle = getDateEndFromWeekNum(week);
    //-------------------------------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const forms = useMyStore((state) => state.outsideserviceLocatorForms);
    const setForms = useMyStore((state) => state.setOutsideserviceLocatorForms);
    const curForms = forms[week] ?? [];
    //-------------------------------------------------------------------------------------------------------------------
    const weekData = defaultData.form;
    const dateString = getDatefromWeekNum(week, dayIndex);
    const [dayData, setData] = useState(defaultData.form[dayIndex]);
    //-------------------------------------------------------------------------------------------------------------------
    const handleSave = async(options) => {
        //--------------------------------------------------------------------
        if(options?.backup && !window.confirm("Are you sure? This will send a back up file to you by email.")) return;
        const formData = new MyFormData();
        formData.append("wk", week);
        formData.append("index", dayIndex);
        if(dayData.workStatus === "Work"){
            formData.append("dayData", JSON.stringify(dayData));
        }else{
            const updatedData = {data: [], overnight: false, status: "Created", workStatus: dayData.workStatus};
            formData.append("dayData", JSON.stringify(updatedData));
            setData(updatedData); 
        }
        if(admin){
            formData.append("userEmail", email);
        }
        //---------------------------------------
        setShowLoader(true);
        if(options?.backup){
            formData.append("formDate", dateString);
            formData.append("realUserName", userName || user.userName);
            formData.append("backup", "yes");
        }
        const res = await myAxios("outside/locator/saveDay.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------
        if(admin){
            setForms(week, curForms.map(allForms => allForms.email === email?
                {...allForms, 
                    [week]:{
                        form: 
                        [
                            ...weekData.slice(0, dayIndex), 
                            {
                                ...dayData, 
                                status: "Saved", 
                                saveTime: getTimeStamp(), 
                            }, 
                            ...weekData.slice(dayIndex + 1)
                        ], week
                    }
                }:allForms)
            );
        }else{
            store.removeDataSet();
            setForms(week, curForms.map(form => form.week === week?{
                ...form, 
                form: [
                    ...weekData.slice(0, dayIndex), 
                    {
                        ...dayData, 
                        status: "Saved", 
                        saveTime: getTimeStamp()
                    }, 
                    ...weekData.slice(dayIndex + 1)
                ], week
            }:form));
        }
    }
    const handleSaveClose = async() => {
        await handleSave({backup: true});
        closeIt();
    }
    const handleSubmit = async() => {
        if(!window.confirm("Are your sure to submit for the day?")) return;
        if(dayData.workStatus === "Work" && getFirstNonLunchIndex(dayData) === false){
            window.alert("No job or event to submit.");
            return;
        }
        if(!dayData.data.find(d => d.category === "lunch") && !window.confirm("You work without lunch?")) return;
        //--------------------------------------------------------------------
        const formData = new MyFormData();
        if(dayData.workStatus === "Work"){
            let totalMins = 0;
            const rawData = calcLocate({...dayData, status: "Submitted"}, dayIndex, dateString, outside);
            // prepare data for generating pdf
            const table = [];
            table.push([
                1, 
                "MOB", 
                rawData.mobInTime,
                rawData.mobInStart,
                rawData.mobInEnd,
                "",
                "",
                "",
                "",
                `Travel From ${rawData.mobInFrom}`
            ]);
            totalMins += rawData.mobInTime;
            rawData.data.forEach((d, i) => {
                switch(d.category){
                    case "job":
                        table.push([
                            i + 2, 
                            d.ticketNumber, 
                            "", 
                            d.start, 
                            d.end, 
                            d.mins, 
                            d.statusGas === "blank"?"":d.statusGas, 
                            d.statusElectric === "blank"?"":d.statusElectric,
                            "'" + d.pmNumber,
                            d.comment
                        ]);
                        break;
                    case "event":
                        totalMins += d.mins;
                        table.push([
                            i + 2, 
                            "", 
                            d.mins,
                            d.start, 
                            d.end, 
                            "",
                            "",
                            "",
                            "'" + d.pmNumber,
                            d.event +": " + d.comment
                        ]);
                        break;
                    case "lunch":
                        table.push([
                            i + 2, 
                            "Lunch", 
                            d.mins,
                            d.start, 
                            d.end, 
                            "", 
                            "", 
                            "", 
                            "", 
                            ""
                        ]);
                        break;
                    default:
                }
            })
            table.push([
                rawData.data.length + 2, 
                "DEMOB", 
                rawData.mobOutTime,
                rawData.mobOutStart,
                rawData.mobOutEnd,
                "",
                "",
                "",
                "",
                `Travel To ${rawData.mobOutTo}`
            ]);
            totalMins += rawData.mobOutTime;
            const col1 = [];
            console.log(totalMins);
            col1.push(
                [rawData.mobInStart], 
                [rawData.lunchTime], 
                [rawData.mobOutEnd], 
                [rawData.regular], 
                [rawData.ot], 
                [rawData.data.filter(d => d.category === "job").length],
                [rawData.mobOutOdometer - rawData.mobInOdometer],
            );
            const col2 = [];
            col2.push(
                [rawData.mobInMoreThan50Miles === "Yes"?"Y":"N"], 
                [rawData.mobOutMoreThan50Miles === "Yes"?"Y":"N"], 
                [rawData.mobInFrom], 
                [rawData.mobOutTo], 
                [rawData.mobInTime], 
                [rawData.mobOutTime],
                [rawData.tollPaid === "Yes"?"Y":"N"],
                [rawData.mobInOdometer],
                [rawData.mobOutOdometer]
            );
            const col3 = [];
            const currentDivision = divisions.data.find(d => d.division === dayData.division);
            col3.push(
                [userName || user.userName], 
                [lanId || user.lanId], 
                [dateString], 
                [currentDivision.division], 
                [currentDivision.supervisorName], 
                [currentDivision.supervisorEmail]
            );
            formData.append("table", JSON.stringify(table));
            formData.append("col1", JSON.stringify(col1));
            formData.append("col2", JSON.stringify(col2));
            formData.append("col3", JSON.stringify(col3));
            formData.append("weekTitle", weekTitle);
            formData.append("formDate", dateString);
            formData.append("form", "locator");
            formData.append("dayData", JSON.stringify(dayData));
        }else{
            const updatedData = {data: [], overnight: false, status: "Created", workStatus: dayData.workStatus};
            formData.append("dayData", JSON.stringify(updatedData));
            setData(updatedData); 
        }
        formData.append("wk", week);
        formData.append("index", dayIndex);
        if(admin){
            formData.append("userEmail", email);
        }
        //---------------------------------------
        setShowLoader(true);
        const res = await myAxios("outside/locator/submitDay.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------
        if(admin){
            setForms(week, curForms.map(allForms => allForms.email === email?
                {...allForms, 
                    [week]:{
                        form: 
                        [
                            ...weekData.slice(0, dayIndex), 
                            {
                                ...dayData, 
                                status: "Submitted", 
                                submitTime: getTimeStamp(), 
                                id: res.data
                            }, 
                            ...weekData.slice(dayIndex + 1)
                        ], week
                    }
                }:allForms)
            );
        }else{
            store.removeDataSet();
            setForms(week, curForms.map(form => form.week === week?{
                ...form, 
                form: 
                [
                    ...weekData.slice(0, dayIndex), 
                    {
                        ...dayData, 
                        status: "Submitted", 
                        submitTime: getTimeStamp(), 
                        id: res.data
                    }, 
                    ...weekData.slice(dayIndex + 1)
                ], week
            }:form));
        }
        closeIt();
    }
    const overnightChange = (e, jobNum) => {
        setData({
            ...dayData, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
                {
                    ...job, 
                    shiftOvernight: e.currentTarget.checked
                }
                :
                {
                    ...job, 
                    shiftOvernight: false
                }
            )
        });
    }
    const valueChange = (e, jobNum, name) => {
        setData({
            ...dayData, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
            {
                ...job, 
                [name]: e.currentTarget.value
            }
            :
            job)
        });
    }
    const valueChange2 = (jobNum, name0, value0, name1, value1) => {
        setData({
            ...dayData, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
            {
                ...job, 
                [name0]: value0, 
                [name1]: value1
            }
            :
            job)
        });
    }
    const TimeChange = (e, jobNum, name) => {
        setData({
            ...dayData,
            mobOutStart: 
            jobNum === (dayData.data.length - 1)?
                e.currentTarget.value
                :
                dayData.mobOutStart, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
                {...job, [name]: e.currentTarget.value}
                :
                jobnumber === jobNum + 1?
                    {...job, start: e.currentTarget.value}
                    :
                    job
            )
        });
    }
    const objectValueChange = (e, name) => {
        const value = e.currentTarget.value;
        setData(dayData => ({
            ...dayData, 
            [name]: value
        }));
    }
    const mobInEndChange = (e) => {
        setData({
            ...dayData, 
            mobOutStart: dayData.data.length === 0?e.currentTarget.value:dayData.mobOutStart,
            mobInEnd: e.currentTarget.value,
            data: dayData.data.map((d, i) => i === 0? ({...d, start: e.currentTarget.value}):d)
        })
    }
    const isLastJobOvernight = () => {
        const jobs = dayData.data;
        for(let i = jobs.length - 1; i >= 0; i--){
            if(jobs[i].category === "job"){
                const job = jobs[i];
                if(
                    job.mobInOvernight || 
                    job.mobInLunchOvernight || 
                    job.lunchOvernight || 
                    job.lunchMobOutOvernight || 
                    job.mobOutOvernight
               ){
                    return true;
                }else{
                    return false;
                }
            }
        }
    }
    //-------------------------------------------------------------------------------------------------------------------
    const prevRef = useRef({});
    useEffect(() => {
        if(prevRef.current.dayIndex === dayIndex && prevRef.current.week === week) return;
        if(!admin && store.getEmail() === user.email && store.getWeek() === week && store.getDay() === String(dayIndex)){
            const localData = store.getData();
            if(localData /* && !Array.isArray(JSON.parse(localData)) */ && localData !== JSON.stringify(dayData) && window.confirm("Do you want to recover from local data?")){
                setData(JSON.parse(localData));
            }
        }
        prevRef.current = { dayIndex, week };
    }, [admin, user.email, dayIndex, week, store, dayData])
    useEffect(() => {
        if(!admin){
            store.setDataSet(user.email, week, String(dayIndex), JSON.stringify(dayData));
        }
    }, [dayData ,admin, dayIndex, user.email, week, store])
    //------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = "Edit Form"
            width = {modalWidth}
            handleFormSubmit = {handleSubmit}
            actionKey = "Submit for the day"
            onSave = {handleSaveClose}
            onSaveTitle = {"Save & Close"}
        >
            <h1 className = "p-3">{admin?`${userName} - `:null}{week?`${dateString}`:null}</h1>
            <div className = "m-4">
                <span>Work Status</span>
                <select className = "form-control ml-3" required value = {dayData.workStatus || ""} onChange = {e => {
                    objectValueChange(e, "workStatus");
                }}>
                    <option value = "">Select</option>
                    <option>Work</option>
                    <option>Off Work</option>
                    <option>Sick</option>
                    <option>Vacation</option>
                </select>
            </div>
            {dayData.workStatus === "Work"?<div>
                <label htmlFor = "backup" className = "inline btn btn-info ml-4">Import Backup file</label>
                <input 
                    id = "backup"
                    type = "file" 
                    style = {{display: "none"}} 
                    onChange = {async e => {
                        const target = e.currentTarget;
                        const files = e.currentTarget.files;
                        if(files.length === 0) return;
                        // if(!window.confirm(`Are you sure to overwrite the existing data?`)) return;
                        const reader = new FileReader();
                        reader.onload = async() => {
                            const result = reader.result;
                            try{
                                const importedData = JSON.parse(result);
                                // check validity of weeknum, dayIndex, email 
                                if("form" in importedData){
                                    setData(importedData.form[dayIndex]);
                                    console.log(importedData.form[dayIndex]);
                                }else{
                                    setData(importedData);
                                }
                            }catch(e){
                                if(e.message.endsWith("not valid JSON")){
                                    alert("Wrong file.");
                                }else{
                                    alert(e.message);
                                }
                            }
                        }
                        reader.readAsText(files[0]);
                        target.value = "";
                    }}
                />
                <ol className = "mt-3" style = {{lineHeight: 2}}>
                    <li>
                        PG&E and 1st/2nd party work needs to be charged to their job specific PM #
                    </li>
                    <li>
                        If a PM is not available, please reach out to the Supervisor/Senior in charge.	
                    </li>
                    
                    <li style = {{color: "red", fontWeight: 650}}>
                        Ensure that your time entries are honest and accurate. Falsely claiming time not worked is considered 	
                    fraud and will not be tollerated. Please "speak up" to your direct supervisor if you have any questions.	
                    </li>
                    <li style = {{color: "red", fontWeight: 650}}>
                        If you work over 5 hours in a day, you are entitled to a meal break of at least 30 minutes that must start before the end of the fifth hour of your shift.
                    </li>
                </ol>
                {/*--------------------------------------------*/}
                <div className = "m-2">
                    <span className = "blk">
                        <span className = "mr-3">Division</span>
                        <select className = "mr-3 form-control inline" value = {dayData.division || ""} required
                            onChange = {e => {
                                objectValueChange(e, "division");
                            }}
                        >
                            <option value = "">Select</option>
                            {divisions.data.filter(d => d.role !== "Superintendent").map((d, i) => <option key = {i}>{d.division}</option>)}
                        </select>
                    </span>
                    {/*
                    <span className = "blk">
                        <span className = "mr-3">Overnight job?</span>
                        <input type = "checkbox" className = "mr-3" style = {{width: 30, height: 30, verticalAlign: "middle"}} value = {dayData.overnight}
                            onChange = {e => {
                                allOvernightChange(e, "overnight");
                            }}
                        />
                    </span>
                    */}
                </div>
                <div className = "m-2">
                    <span className = "blk">
                        <span className = "mr-3">MOB from?</span>
                        <select className = "mr-3 form-control inline" value = {dayData.mobInFrom || ""} required
                            onChange = {e => {objectValueChange(e, "mobInFrom");}}
                        >
                            <option value = "">Select</option>
                            <option>Home</option>
                            <option>Hotel</option>
                        </select>
                    </span>
                    <span className = "blk">
                        <span className = "mr-3">is MOB more than 50 miles?</span>
                        <select className = "mr-3 form-control inline" value = {dayData.mobInMoreThan50Miles || ""} required
                            onChange = {e => {objectValueChange(e, "mobInMoreThan50Miles");}}
                        >
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </span>
                    <span className = "blk"> 
                        <span className = "mr-3">MOB Odometer</span>
                        <input className = "mr-3 form-control numInline" type = "number" step = {1} value = {dayData.mobInOdometer || ""} min = {0} required
                            onChange = {e => {objectValueChange(e, "mobInOdometer");}}
                        />
                    </span>
                </div>
                <div className = "border rounded p-4 m-2">
                    <span className = "blk">
                        <span className = "mr-3">1. MOB start</span>
                        <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {dayData.mobInStart || ""} required
                            onChange = {e => {objectValueChange(e, "mobInStart");}}
                        />
                    </span>
                    <span className = "blk"> 
                        <span className = "mr-3">MOB end</span>
                        <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {dayData.mobInEnd || ""} required
                            min = {dayData.mobInStart}
                            onChange = {e => mobInEndChange(e)}
                        />
                    </span>
                </div>
                <div className = "mb-3">
                    <span className = "btn btn-success m-3" 
                        onClick = {() => {
                            if(isLastJobOvernight()){
                                window.alert("Remove overnight to add new job at this day!");
                                return;
                            }
                            setData({
                                ...dayData, 
                                data:
                                [{
                                    category: "job",
                                    start: dayData.mobInEnd
                                }, ...dayData.data]
                            });
                        }}
                    >
                        Add Ticket Below
                    </span>
                    <span className = "btn btn-info m-3" 
                        onClick = {() => {
                            if(isLastJobOvernight()){
                                window.alert("Remove overnight to add new job at this day!");
                                return;
                            }
                            setData({
                                ...dayData, 
                                data:
                                [{
                                    category: "event",
                                    start: dayData.mobInEnd
                                }, ...dayData.data]
                            });
                        }}
                    >
                        Add Event Below
                    </span>
                    <span className = "btn btn-warning m-3" 
                        onClick = {() => {
                            if(dayData.data.find(d => d.category === "lunch")){
                                if(!window.confirm("You already added lunch row. Add more?")) return
                            }
                            setData({
                                ...dayData, 
                                data:
                                [{
                                    category: "lunch",
                                    start: dayData.mobInEnd
                                }, ...dayData.data]
                            });
                        }}
                    >
                        Add Lunch Below
                    </span>
                    <span className = "btn btn-secondary m-3" onClick = {() => handleSave({backup: true})}>
                        Save
                    </span>
                </div>
                {dayData.data.map((job, jobNum) => (
                <div className = "border rounded p-2 m-2" key = {jobNum}>
                    {job.category === "job"?
                    <div className = "mb-3">
                        <div className = "m-2">
                            
                            <span className = "blk">
                                <span className = "mr-3">{jobNum + 2}. Ticket Number</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.ticketNumber || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "ticketNumber");}}
                                />
                            </span>

                            <span className = "blk">
                                <span className = "mr-3">Start</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} 
                                type = "time" disabled value = {job.start || ""}
                                />
                            </span>

                            {dayData.overnight?
                            <span className = "blk">
                                <input className = "mr-1" type = "checkbox" style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                                    checked = {job.shiftOvernight || false} 
                                    onChange = {e => overnightChange(e, jobNum)}
                                />
                                <span className = "mr-3">Overnight</span>
                            </span>
                            :null}
                            <span className = "blk">
                                <span className = "mr-3">End</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {job.end || ""} step = "0" required
                                    min = {job.start}
                                    onChange = {e => {
                                        //validate time
                                        //const currentjob = (dayData.data.find((job, jobnumber) => jobnumber === jobNum));
                                        TimeChange(e, jobNum, "end");
                                    }} 
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            {/*---------------- Status Gas -----------------*/}
                            <span className = "blk">
                                <span className = "mr-3">Status Gas</span>
                                <select
                                    className = "mr-3 form-control inline"
                                    required
                                    value = {job.statusGas || ""}
                                    onChange = {e => {
                                        valueChange(e, jobNum, "statusGas");
                                    }}
                                >
                                    <option value = "">Select</option>
                                    <option>Feild Meet</option>
                                    <option value = "blank">No facilities were marked</option>
                                    {/*---------------------------------*/}
                                    {Object.keys(LMStatusOpts).map((key, keyIndex) => <optgroup key = {keyIndex} label = {key}>
                                        {LMStatusOpts[key].map((value, valueIndex) => <option key = {valueIndex}>{value}</option>)}
                                    </optgroup>)}
                                    {![...Object.values(LMStatusOpts).reduce(arrayReducer, []), "", "Feild Meet", "blank"].includes(job.statusGas)?<option>{job.statusGas}</option>:<></>}
                                </select>
                            </span>
                            {/*---------------- Status Electric -----------------*/}
                            <span className = "blk">
                                <span className = "mr-3">Status Electric</span>
                                <select
                                    className = "mr-3 form-control inline"
                                    required
                                    value = {job.statusElectric || ""} 
                                    onChange = {e => {
                                        valueChange(e, jobNum, "statusElectric");
                                    }}
                                >
                                    <option value = "">Select</option>
                                    <option>Feild Meet</option>
                                    <option value = "blank">No facilities were marked</option>
                                    {/*---------------------------------*/}
                                    {Object.keys(LMStatusOpts).map((key, keyIndex) => <optgroup key = {keyIndex} label = {key}>
                                        {LMStatusOpts[key].map((value, valueIndex) => <option key = {valueIndex}>{value}</option>)}
                                    </optgroup>)}
                                    {![...Object.values(LMStatusOpts).reduce(arrayReducer, []), "", "Feild Meet", "blank"].includes(job.statusElectric)?<option>{job.statusElectric}</option>:<></>}
                                </select>
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">PM Number</span>
                                <span>{dayData.division in PMNumbers?"":dayData.division}</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.pmNumber || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "pmNumber");}}
                                    pattern = "(?!0{8})[0-9]{8}"
                                    list = "PMNumbers"
                                />
                                <span style = {{color: "red"}}>
                                    {job.pmNumber?.match(/^[0-9]{8}$/)?null:<>* 8 digit number *</>}
                                    {job.pmNumber?.match(/^0{8}$/)?<>* use Event for non-billable instead *</>:null}
                                </span>
                                <datalist id = "PMNumbers">
                                    {PMNumbers[dayData.division]?.map((d, di) => <option key = {di} value = {d.value}>{d.name}</option>)}
                                    <option value = {"43533937"}>FIRE PM</option>
                                    <option value = {"02055506"}>PG&E Non-Productive</option>
                                    <option value = {"02051388"}>Fiber Optic Locates</option>
                                    <option value = {"02052285"}>Digital Catalyst</option>
                                    <option value = {"02051446"}>Miscellaneous Charges</option>
                                </datalist>
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">Location/Comment</span>
                                <textarea className = "mr-3 form-control inline" type = "text" style = {{minWidth: "60vw"}} value = {job.comment || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "comment");}}
                                />
                            </span>
                        </div>
                    </div>
                    :null}
                    {job.category === "event"?
                    <div className = "mb-3">
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">{jobNum + 2}. Event</span>
                                <select className = "mr-3 form-control inline" required
                                    value = {job.event || ""} 
                                    onChange = {e => {
                                        const event = e.currentTarget.value;
                                        const mapEvent = v => {
                                            switch(v){
                                                case "Fiber Optic Locates":
                                                    return "02051388";
                                                case "Miscellaneous Charges":
                                                    return "02051446";
                                                case "TSC":
                                                case "Digital Catalyst":
                                                    return "02052285";
                                                case  "Training":
                                                case "PG&E Non-Productive time":
                                                case "PG&E Call":
                                                case "PG&E WBT":
                                                    if(
                                                        dayData.division === "BTL Fresno Yard" ||
                                                        dayData.division === "BTL Hayward Yard" ||
                                                        dayData.division === "BTL Sacramento Yard"
                                                   ){
                                                        return "00000000";
                                                    }
                                                    return "02055506";
                                                    //return PMNumbers[dayData.division].find(p => p.name.includes("Locate & Mark - Dist") > -1).value;
                                                default: 
                                                    return "00000000";
                                            }
                                        }
                                        // drug test 42910666
                                        if(!dayData.division){
                                            window.alert("Please select your division first.");
                                            return;
                                        }

                                        if(event === "BESS Non-Productive time"){
                                            window.alert("PLEASE NOTE: Bess supervisor approval required");
                                        }
                                        valueChange2(
                                            jobNum, 
                                            "event", event, 
                                            "pmNumber", 
                                            mapEvent(event) || ""
                                        );
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {eventOptions.sort().map((o, oi) => <option key = {oi}>{o}</option>)}
                                </select>
                                {job.event || ""}
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">Notes</span>
                                <textarea className = "mr-3 form-control inline" type = "text" style = {{minWidth: "60vw"}} value = {job.comment || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "comment");}}
                                    placeholder  = {job.event === "PG&E Non-Productive time" || job.event === "BESS Non-Productive time"?"Required":null}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">PM Number</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.pmNumber || ""} required
                                    readOnly = {job.event?true:false}
                                    onChange = {e => {valueChange(e, jobNum, "pmNumber");}}
                                    pattern = "[0-9]{8}"
                                    list = "PMNumbers2"
                                /> {job.pmNumber?.match(/^[0-9]{8}$/)?null:<>* 8 digit number *</>}
                                <datalist id = "PMNumbers2">
                                    {PMNumbers[dayData.division]?.map((d, di) => <option key = {di} value = {d.value}>{d.name}</option>)}
                                    <option value = {"43533937"}>FIRE PM</option>
                                    <option value = {"00000000"}>Non-Billable</option>
                                </datalist>
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">Start</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} 
                                    type = "time" disabled value = {job.start || ""} 
                                />
                            </span>
                            {dayData.overnight?
                            <span className = "blk">
                                <input className = "mr-1" type = "checkbox" style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                                    checked = {job.shiftOvernight || false} 
                                    onChange = {e => overnightChange(e, jobNum)}
                                />
                                <span className = "mr-3">Overnight</span>
                            </span>
                            :null}
                            <span className = "blk">
                                <span className = "mr-3">End</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {job.end || ""} step = "0" required
                                    min = {job.start}
                                    onChange = {e => {
                                        //validate time
                                        //const currentjob = (dayData.data.find((job, jobnumber) => jobnumber === jobNum));
                                        TimeChange(e, jobNum, "end");
                                    }} 
                                />
                            </span>
                        </div>
                    </div>
                    :null}
                    {job.category === "lunch"?
                    <div className = "mb-3">
                        <span className = "blk">
                            <span className = "mr-3">{jobNum + 2}. Lunch</span>
                        </span>
                        <span className = "blk">
                            <span className = "mr-3">Start</span>
                            <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} 
                                type = "time" disabled value = {job.start || ""} 
                            />
                        </span>
                        {dayData.overnight?
                        <span className = "blk">
                            <input className = "mr-1" type = "checkbox" style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                                checked = {job.shiftOvernight || false} 
                                onChange = {e => overnightChange(e, jobNum)}
                            />
                            <span className = "mr-3">Overnight</span>
                        </span>
                        :null}
                        <span className = "blk">
                            <span className = "mr-3">End</span>
                            <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {job.end || ""} step = "0" required
                                min = {job.start}
                                onChange = {e => {
                                    //validate time
                                    //const currentjob = (dayData.data.find((job, jobnumber) => jobnumber === jobNum));
                                    TimeChange(e, jobNum, "end");
                                }} 
                            />
                        </span>
                    </div>
                    :null}
                    <div className = "mb-3">
                        <span className = "btn btn-danger mx-3" onClick = {() => {
                            if(!window.confirm("Are you sure to delete this?")) return;
                            setData({
                                ...dayData, 
                                mobOutStart: dayData.data.length === 1?
                                dayData.mobInEnd
                                    :
                                    jobNum === (dayData.data.length - 1)?dayData.data[dayData.data.length - 2].end:dayData.mobOutStart
                                ,
                                data:
                                dayData.data.map(
                                    (j, jobnumber) => jobNum === 0 && jobnumber === 1?
                                        ({...j, start: dayData.mobInEnd})
                                        :
                                        jobnumber === (jobNum + 1)?
                                            ({...j, start: dayData.data[jobnumber - 2].end})
                                            :
                                            j
                                )
                                .filter((_, jobnumber) => (jobNum !== jobnumber))
                            });
                        }}>
                            Delete This
                        </span>
                        <span className = "btn btn-success m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight()){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [...dayData.data.slice(0, jobNum + 1), {
                                        category: "job",
                                        start: dayData.data.length?
                                        dayData.data[jobNum].end
                                            :
                                            dayData.mobInEnd
                                    }, ...dayData.data.slice(jobNum + 1)]
                                });
                            }}
                        >
                            Add Ticket Below
                        </span>
                        <span className = "btn btn-info m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight()){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [...dayData.data.slice(0, jobNum + 1), {
                                        category: "event",
                                        start: dayData.data.length?dayData.data[jobNum].end:dayData.mobInEnd
                                    }, ...dayData.data.slice(jobNum + 1)]
                                });
                            }}
                        >
                            Add Event Below
                        </span>
                        <span className = "btn btn-warning m-3" 
                            onClick = {() => {
                                if(dayData.data.find(d => d.category === "lunch")){
                                    if(!window.confirm("You already added lunch row. Add more?")) return
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [...dayData.data.slice(0, jobNum + 1), {
                                    category: "lunch",
                                    start: dayData.data.length?dayData.data[jobNum].end:dayData.mobInEnd
                                    }, ...dayData.data.slice(jobNum + 1)]
                                });
                            }}
                        >
                            Add Lunch Below
                        </span>
                        <span className = "btn btn-secondary m-3" onClick = {handleSave}>
                            Save
                        </span>
                    </div>
                </div>
                ))}
                <div className = "border rounded p-4 m-2"> 
                    <span className = "blk">
                        <span className = "mr-3">{dayData.data.length + 2} DEMOB start</span>
                        <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} 
                        type = "time" disabled value = {dayData.mobOutStart || ""} 
                        />
                    </span>
                    <span className = "blk"> 
                        <span className = "mr-3">DEMOB end</span>
                        <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {dayData.mobOutEnd || ""} required
                            min = {dayData.mobOutStart}
                            onChange = {e => {objectValueChange(e, "mobOutEnd");}}
                        />
                    </span>
                </div>
                <div className = "m-2">
                    <span className = "blk">
                        <span className = "mr-3">DEMOB to?</span>
                        <select className = "mr-3 form-control inline" value = {dayData.mobOutTo || ""} required
                            onChange = {e => {objectValueChange(e, "mobOutTo");}}
                        >
                            <option value = "">Select</option>
                            <option>Home</option>
                            <option>Hotel</option>
                        </select>
                    </span>
                    <span className = "blk">
                        <span className = "mr-3">is DEMOB more than 50 miles?</span>
                        <select className = "mr-3 form-control inline" value = {dayData.mobOutMoreThan50Miles || ""} required
                            onChange = {e => {objectValueChange(e, "mobOutMoreThan50Miles");}}
                        >
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </span>
                    <span className = "blk">
                        <span className = "mr-3">DEMOB Odometer</span>
                        <input className = "mr-3 form-control numInline" type = "number" step = {1} value = {dayData.mobOutOdometer || ""} 
                            min = {dayData.mobInOdometer} required
                            onChange = {e => {objectValueChange(e, "mobOutOdometer");}}
                        />
                    </span>
                </div>
                <div className = "m-2">
                    <span className = "blk">
                        <span className = "mr-3">Tolls paid?</span>
                        <select className = "mr-3 form-control inline" value = {dayData.tollPaid || ""} required
                            onChange = {e => {objectValueChange(e, "tollPaid");}}
                        >
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </span>
                </div>
                {false?
                <div className = "m-2">
                    <span className = "btn btn-info" onClick = {() => {handleSave({backup: true})}}>Back up</span>
                </div>
                :<></>}
            </div>:
            null
            }
        </Modal>
    )
}